// removed by extract-text-webpack-plugin
module.exports = {"secured-payment":"secured-payment__6TRED","logo":"logo__2Tpd3","separator":"separator__3oyzy","separator-desktop":"separator-desktop__1BcML","icon":"icon__3Yl9h","text":"text__UK2qE","your-order":"your-order__mt6MN"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/raffleForm/styles/SecuredPaymentInfo.scss
// module id = qN6z
// module chunks = 1